module.exports = __webpack_public_path__ + "static/media/chica.2ccb8091.png";